import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CandidateResume as ICandidateResume, getLatestCvOfCandidates } from 'wisestep-api';

import { useCandidateViewData } from '../../utils/CandidateViewContext';
import CandidateProfileDetails from '../childComponets/CandidateProfileDetails/CandidateProfileDetails';
import CandidateResume from '../childComponets/CandidateResume';
import Resizable from '../childComponets/resizable/Resizable';
import EmptyContentMessage from '../documents/components/EmptyContentMessage';

const CandidateProfile = () => {
  const { candidateViewData } = useCandidateViewData();
  const isInDnc =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);
  const [resumeDocument, setResumeDocument] = useState<ICandidateResume>();
  const [params] = useSearchParams();
  useEffect(() => {
    const fetchResume = async () => {
      const candidateId = params.get('id') ?? '';
      if (candidateId) {
        try {
          const res = await getLatestCvOfCandidates([candidateId]);
          setResumeDocument(res.data[0]);
        } catch (e) {
          console.error('Error fetching candidate resume:', e);
        }
      }
    };

    fetchResume();
  }, [params]);
  return (
    <>
      {candidateViewData && (
        <Resizable
          rightPanel={
            <Box>
              {isInDnc ? (
                <EmptyContentMessage
                  title="No CV"
                  subtitle="Oops! Candidate CVs are not available."
                  marginTop={0}
                  height={680}
                />
              ) : (
                <CandidateResume
                  job={null}
                  resumeLocation={resumeDocument?.resumeLocation ?? ''}
                  pdfResumeUrl={resumeDocument?.resumeLocation ?? ''}
                  resumeFileName={resumeDocument?.resumeFileName ?? ''}
                  showUpload={true}
                />
              )}
            </Box>
          }
          leftPanel={<CandidateProfileDetails candidate={candidateViewData} />}
          defaultSizes={[50, 50]}
          minSize="25%"
          maxSize="75%"
          rightVerticalScroll={false}
        />
      )}
    </>
  );
};

export default CandidateProfile;
